<template>
  <div>
    <div class="ebookdiv">
      
            <div class="ebook">
                  <title-bar class="titlebar" :ifTitleAndMenuShow="ifTitleAndMenuShow">{{bookname}}</title-bar>
                      <div class="read-wrapper">
                          <div class="read" id="read"></div>
                          <div class="width: 200px;
                                color: #00cccc;">
                              <div class="left" @click="prevPage"></div>
                              <div class="center" @click="toggleTitleAndMenu"></div>
                              <div class="right" @click="nextPage"></div>
                          </div>
                      </div>

                      <div class="btndiv">
                      <span class="btndown" @click="nextPage">下一页</span>
                      
                      <span class="btnup" @click="prevPage">上一页|</span>  
                     
                    </div>
                      <menu-bar :ifTitleAndMenuShow="ifTitleAndMenuShow" 
                                @getCurrentLocation="getCurrentLocation"
                                :fontSizeList = "fontSizeList" 
                                :defaultFontSize="defaultFontSize"
                                @setFontSize="setFontSize" 
                                :themeList="themeList" 
                                :defaultTheme="defaultTheme"
                                @setTheme = "setTheme" 
                                :bookAvailable = "bookAvailable" 
                                @onProgressChange = "onProgressChange"
                                @jumpTo="jumpTo"
                                :navigation = "navigation"
                                :parentProgress = "progress"
                                ref="menuBar">
                        </menu-bar>
                  </div>
    </div>

  </div>
</template>

<script>
// const DOWNLOAD_URL ='http://peopleimg.img-cn-beijing.aliyuncs.com/2019/04/10/7b23076b4a35436c18b3e0d233112b6c8706.epub'9787559841483;

import Epub from 'epubjs';
import $ from 'jquery';
export default {
  name: "app",
  data() {
    return {
      data: "",
      page: 1,
      dataSize: 1,
      isbn:this.$route.query.isbn,
      bookname:this.$route.query.bookname,
    };
  },
  methods: {
    prevPage(){
            // Rendition.prev
            if(this.rendition){
                this.rendition.prev().then(()=>{
                   this.showProgress()
                })
            }
        },

        nextPage(){
            // Rendition.next
            if(this.rendition){
                this.rendition.next().then(()=>{
                   this.showProgress()
                })
            }
        },
            // 电子书的解析和渲染
            showEpub(){
            // 生成book,Rendition,
            const DOWNLOAD_URL = 'http://api.xuelintianxia.com/res/epub/' + this.isbn +'.epub';
            console.log("路径",DOWNLOAD_URL);
            this.book = new Epub(DOWNLOAD_URL)
            this.rendition = this.book.renderTo('read',{
                width:'1200px',
                height:'700px'
            })
            // 通过Rendition.display渲染电子书
            this.rendition.display()
            // 获取Theme对象
            this.themes = this.rendition.themes
            // 设置默认字体
            this.setFontSize(this.defaultFontSize)
            // this.themes.register(name,styles)
            this.registerTheme()
            // this.themes.select(name)
            this.setTheme(this.defaultTheme)
            // 获取locations对象 epubjs的钩子函数实现
            this.book.ready.then(()=>{
                this.navigation = this.book.navigation
                //console.log(this.navigation.toc);
                var $select=document.getElementById('toc');
                var docfrag=document.createDocumentFragment();
                this.navigation.toc.forEach(function(chapter){
                  var option=document.createElement("option");
                  option.textContent=chapter.label;
                  option.ref=chapter.href;

                  //var option=document.createElement("a");
                  //option.setAttribute('href',chapter.href);
                  //option.textContent=chapter.label;

                  //console.log(option);
                  docfrag.appendChild(option);
                  
                })
                $select.appendChild(docfrag);
                //$select.onchange=this.jumpTo();
                $select.onchange=function(){
                  console.log('切换目录！');
                  var index=$select.selectedIndex;
                  var url=$select.options[index].ref;
                  console.log(url);
                 // this.rendition.display(url);
                  //jumpTo(url);
                    
                  //this.rendition.display();
                  //return false;
                }
               
                return this.book.locations.generate()
            }).then(result=>{
                // console.log(result);
                this.locations = this.book.locations
                this.bookAvailable = true
            })
        }
  },
  created() {
    this.showEpub();
    this.$http
      .get(`${this.$store.state.baseurl}/api/readbook?id=1&page=${this.page}`)
      .then((res) => {
        const json = res.data;
        const obj = JSON.parse(json);
        this.data = obj.data;
        this.page = obj.page;
        this.dataSize = obj.dataSize;
      });
  },
};
</script>

<style scoped lang="scss">
.titlebar{
  font-size: 30px;
  margin-top: 50px;
}
.ebookdiv{
  margin-top: 25px;
}
.read {
  width: 1200px;
  margin: 0 auto;
  background-color: #ffffff;
}
.btndiv{
  width: 1200px;
  margin: 0 auto;
  padding-bottom: 50px;
  .btnup{
   float: right;
   cursor: pointer;
}
.btndown{
  float: right;
  cursor: pointer;
}
}

.ebook{
    position: relative;
    .read-wrapper{
        .mask{
            position: absolute;
            display: flex;
            top: 0;
            left: 0;
            width: 80%;
            height: 70%;
            z-index: 9;
            .left{
                flex: 0 0 px2rem(100);
                width: 200px;
                color: #00cccc;
                
            }
            .center{
                flex: 1;
                
            }
            .right{
                flex: 0 0 px2rem(100);
                width: 200px;
                color: #00cccc;
               
            }
        }
    }
}
</style>
